/**
 * Created by Victor Rojo on 1/9/17.
 */
import { Component }                from '@angular/core';
import { FormGroup, FormControl,
         FormBuilder, Validators, AbstractControl }  from '@angular/forms';
import { NotificationsService }     from 'angular2-notifications';

import { AuthService }  from '../auth.service';
import { Credential }   from "../credential";
import { I18NService }  from "../../i18n/i18n.service";

@Component({
  templateUrl: './try-demo.component.html',
  styleUrls: ['./try-demo.component.css'],
})
export class TryDemoComponent{

  signupForm: FormGroup;
  isBusy = false;
  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };
  tenant = '';
  customization = '';
  siteKey = '6LcZDTMUAAAAAFVKJHTL88JquE-QglGbFkuK5GJx';
  cookiePolicy= true;

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private i18nService: I18NService,
              private notificationService: NotificationsService) {
    this.signupForm = fb.group({
      'name' : [null, Validators.required],
      'email' : [null, Validators.compose([Validators.required, Validators.email])],
      'company' : [null, Validators.required],
      'captcha': [null, Validators.required],
    });

    if ( document.location.hostname  == "galp.cloud.ipetrol.es") {
      this.customization = "galp ipetrol";
      this.tenant = "galp";
      this.cookiePolicy = false;
    } else if ( document.location.hostname  == "cloud.ipetrol.es" ) {
      this.customization = " ipetrol";
      this.tenant = "";
      this.siteKey = "6Lf_5ZAUAAAAAKGd7HiGZ2nMfz-PbHcx4Re7GtLx";
      this.cookiePolicy = false;
    }
  }

  signupDemo():void{
    let demoData = {
      name: this.signupForm.controls["name"].value,
      email: this.signupForm.controls["email"].value,
      company: this.signupForm.controls["company"].value,
    };

    if ( this.signupForm.valid ) {
      this.isBusy = true;
      this.authService.loginDemo(demoData)
        .then(res => {
          this.isBusy = false;
        })
        .catch( error => {
          this.isBusy = false;
          this.notificationService.error(
            this.i18nService.get("error"),
            this.i18nService.get("errorLoginInstance")
          );
        });
    } else {
      this.markFormGroupTouched(this.signupForm);
    }
  }

  protected markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control:AbstractControl) => {
      control.markAsTouched();
      if (control['controls']) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }
}
